import React from 'react'
import { Route, Navigate } from 'react-router-dom'

import { isAuthenticated } from '@/resources/services/permission/auth'

const Login = React.lazy(
  () => import('../pages/Login' /* webpackChunkName: 'login' */)
)
const RecoverPassword = React.lazy(
  () =>
    import('../pages/RecoverPassword' /* webpackChunkName: 'recoverPassword' */)
)
const SignUpPage = React.lazy(
  () => import('../pages/SignUpPage' /* webpackChunkName: 'signUpPage' */)
)
const RegisterConfirmed = React.lazy(
  () =>
    import(
      '../pages/RegisterConfirmed' /* webpackChunkName: 'registerConfirmed' */
    )
)
const LandingPagePDV = React.lazy(
  () =>
    import('../pages/LandingPagePDV' /* webpackChunkName: 'landingPagePDV' */)
)

export default (
  <>
    <Route
      path="login"
      element={isAuthenticated() ? <Navigate to="/poc-orders" /> : <Login />}
    />
    <Route path="recover" element={<RecoverPassword />} />
    <Route path="cadastro-parceiro">
      <Route index element={<LandingPagePDV />} />
      <Route path="formulario" element={<SignUpPage />} />
      <Route path="sucesso" element={<RegisterConfirmed />} />
    </Route>
  </>
)
